import { ExpressCheckoutDS, type ExpressCheckoutProps } from '@src/components/blocks/express-checkout-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { withErrorBoundary } from '../errorBoundary'

import { ExpressCheckoutLegacy } from './express-checkout-legacy'

function ExpressCheckout(props: ExpressCheckoutProps) {
  if (shouldUseDesignSystem()) {
    return <ExpressCheckoutDS {...props} />
  }

  return <ExpressCheckoutLegacy {...props} />
}

export type { ExpressCheckoutProps }
export default withErrorBoundary(ExpressCheckout)
